import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "event_repeat",
    title: "Scheduled Inspections",
    description:
      "We carry out regular property inspections to identify issues early and keep your property in good condition throughout the tenancy.",
  },
  {
    icon: "build",
    title: "Routine Servicing",
    description:
      "We arrange servicing of boilers, heating systems, and other building services on a planned schedule to prevent breakdowns.",
  },
  {
    icon: "savings",
    title: "Reduced Emergency Costs",
    description:
      "By addressing minor issues proactively, we reduce the likelihood of costly emergency repairs and unplanned disruption.",
  },
  {
    icon: "fact_check",
    title: "Compliance Maintenance",
    description:
      "We track certification renewals and regulatory obligations, ensuring your property remains compliant at all times.",
  },
];

function PlannedMaintenance_Section1() {
  return <ServiceHighlights title="Why Choose Our Planned Preventive Maintenance?" items={items} />;
}

export default PlannedMaintenance_Section1;
